import { z } from 'zod';
/** Numbered controls inside the visible challenge, selected by the extension. */
export const challengeElementSchema = z
    .object({
    n: z.int().min(1),
    tag: z.string().max(32),
    text: z.string().max(200),
    kind: z.enum(['click', 'text']),
    /** Only a recognized combined tracking/challenge form; bound to the claimed job on both ends. */
    reference_key: z.enum(['container', 'bl']).optional(),
    /** Offered only after typing and blur, while the same value still needs confirmation. */
    confirm_methods: z.array(z.literal('enter')).min(1).max(1).optional(),
})
    .refine((element) => !element.reference_key || (element.kind === 'text' && element.tag === 'input'), {
    message: 'A job reference must be a text input',
})
    .refine((element) => !element.confirm_methods || element.kind === 'text', {
    message: 'Only a text control can offer field confirmation',
});
/** Deliberately narrower than navigation: no URLs, scripts, coordinates or arbitrary selectors. */
export const challengeMoveSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('click'), element: z.int().min(1) }).strict(),
    z.object({ kind: z.literal('type'), element: z.int().min(1), text: z.string().min(1).max(200) }).strict(),
    z.object({ kind: z.literal('confirm'), element: z.int().min(1), method: z.literal('enter') }).strict(),
    z.object({ kind: z.literal('wait') }).strict(),
    /** Advisory only: the extension must independently observe that the challenge cleared. */
    z.object({ kind: z.literal('done') }).strict(),
    z.object({ kind: z.literal('give_up'), reason: z.string().min(1).max(500) }).strict(),
]);
/** `POST /extension/jobs/{job_id}/challenge-move`, independent from normal navigation. */
export const challengeMoveRequestSchema = z.object({
    job_id: z.string(),
    client_name: z.string().min(1).max(32).optional(),
    url: z.string().max(2048),
    signal: z.string().max(500),
    screenshot_jpeg_base64: z.string().min(1),
    page_text: z.string().max(4000),
    elements: z
        .array(challengeElementSchema)
        .max(80)
        .refine((elements) => new Set(elements.map((element) => element.n)).size === elements.length, 'Challenge element numbers must be unique'),
    history: z.array(challengeMoveSchema).max(8),
    last_error: z.string().max(500).nullable().optional(),
});
export const challengeMoveResponseSchema = z.object({
    move: challengeMoveSchema,
    moves_left: z.int().min(0).max(8),
    model: z.string(),
});
//# sourceMappingURL=challenge.schema.js.map